import { render } from "./SystemModule.vue?vue&type=template&id=be74d0d8&scoped=true"
import script from "./SystemModule.vue?vue&type=script&lang=js"
export * from "./SystemModule.vue?vue&type=script&lang=js"

import "./SystemModule.vue?vue&type=style&index=0&id=be74d0d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-be74d0d8"

export default script